import {fetchDelete, fetchGet, fetchPatch, fetchPost, generateEndpoint} from "../../../utils/request";

export const addRule = async({ token, rule }) => {
  const url = `${generateEndpoint('createRule')}`
  return fetchPost(url, token, { rule })
}

export const getRules = async(token: string) => {
  const url = `${generateEndpoint('getRules')}`
  return fetchGet(url, token)
}

export const updateRule = async({ token, rule }) => {
  const url = `${generateEndpoint('updateRule')}`
  return fetchPatch(url, token, { rule })
}

export const updateRoleStatus = async({ token, id, enabled }) => {
  const url = `${generateEndpoint('updateRuleStatus')}`
  return fetchPatch(url, token, { id, enabled })
}

export const deleteRule = async({ token, id }) => {
  const url = `${generateEndpoint('deleteRule')}`
  return fetchDelete(url, token, { id })
}
